module.exports = __webpack_public_path__ + "static/assets/4603bbb8b2154345ab225b800fb74d9a.gif";